import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error: authError } = await supabase.auth.signInWithPassword({ email, password: pw });
    setLoading(false);
    if (authError) {
      setError('이메일 또는 비밀번호가 틀렸습니다.');
      setPw('');
    } else {
      navigate('/admin/dashboard');
    }
  };

  return (
    <div className="admin-login-wrap">
      <form onSubmit={handleSubmit} className="admin-login-form">
        <h1 className="admin-login-title">Admin</h1>
        <input
          type="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError(''); }}
          placeholder="Email"
          className="admin-input"
          autoFocus
        />
        <input
          type="password"
          value={pw}
          onChange={(e) => { setPw(e.target.value); setError(''); }}
          placeholder="Password"
          className="admin-input"
        />
        {error && <p className="admin-login-error">{error}</p>}
        <button type="submit" className="admin-btn-primary" disabled={loading}>
          {loading ? '로그인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}
